import { render } from "./ShelvesPage.vue?vue&type=template&id=175f8b90&scoped=true"
import script from "./ShelvesPage.vue?vue&type=script&lang=js"
export * from "./ShelvesPage.vue?vue&type=script&lang=js"

import "./ShelvesPage.vue?vue&type=style&index=0&id=175f8b90&scoped=true&lang=css"

import exportComponent from "F:\\omar pos 2\\pos_administration_platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175f8b90"]])

export default __exports__